import React from 'react';
import { Col, Row } from 'antd';

import './style.less';

const LeadPageHzSection = ({ id, title, data }) => {
  let spans = {
    xs: { span: 24 },
    md: { span: 12 },
    lg: { span: 6 },
  };
  if (data.length === 3) {
    spans = {
      xs: { span: 24 },
      md: { span: 8 },
    };
  }
  return (
    <div className="lead-page-hz-section py-16 px-4" id={id}>
      <h2 className="text-center leading-snug">{title}</h2>
      <Row gutter={[0, 40]} className="mt-8">
        {data.map((d, index) => (
          <Col {...spans} key={index}>
            <div className="text-center pr-4 pl-4">
              <img
                className="ml-auto mr-auto"
                alt={d.iconAlt}
                width="140"
                height="140"
                src={d.icon}
                loading="lazy"
              />
              <h3 className="font-bold mt-5 leading-snug">{d.title}</h3>
              <p className="os-text-17 leading-snug">{d.description}</p>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default LeadPageHzSection;
